/* app/ui/nav/load */

import $ from 'jquery';
import Velocity from 'velocity-animate';

import { MediaQueries } from 'Util/mediaqueries';
import * as Keybinding from 'Util/keybinding';
import { NavSmall } from 'App/nav/small';
import { NavLarge } from 'App/nav/large';
import { HeaderSticky } from 'App/nav/sticky';
import { publish, subscribe } from 'Util/pubsub';

var selectors = {
	header: '.js-header',
	notification: '.js-header-notification',
	nav: '.js-navigation',
	navItem: '.js-navigation__item',
	navItemMega: '.js-navigation__item--megamenu',
	megamenuHeading: '.js-megamenu__heading',
	body: '.js-body',
	headerSearchSubmit: '.js-header-search-submit',
	searchInput: '.js-ss360-search-input',
};
var classes = {
	headerUp: 'is-up',
	headerDown: 'is-down',
	headerSticky: 'is-sticky',
	headerNavOpen: 'is-open',
	bodyNavOpen: 'nav-showing',
	allowAnimations: 'allow-animations',
	searchExpanded: 'search-expanded',
};

var States = {
	INITIAL: 'initial',
	OPENED: 'opened',
	CLOSED: 'closed'
};

var $nav;
var $search;
var $searchToggle;
var $langToggle;
var $lang;
var $body;
var $header;
var $footerSearch
var $headerSearchSubmit;
var $searchInput;

var module = {
	init: function() {
		module._initElements();
		if ($nav.length) {
			module._initSubscriptions();
			module._initEvents();
			module._initMediaQueries();
		}

		HeaderSticky.init(selectors);
	},

	_initElements: function() {
		$nav = $(selectors.nav);
		$body = $(selectors.body);
		$header = $(selectors.header);
		$searchToggle = $('.js-header__search-toggle');
		$search = $('.js-header__search');
		$langToggle = $('.js-header__lang-toggle');
		$lang = $('.js-header__lang');
		$footerSearch = $('.js-header__search-open');
		$headerSearchSubmit = $(selectors.headerSearchSubmit);
		$searchInput = $(selectors.searchInput);
	},

	_initSubscriptions: function () {
		subscribe('/nav/navToggle', module._closeSearch);
		subscribe('/nav/langToggle', module._closeSearch);
		subscribe('/nav/navToggle', module._closeLang);
		subscribe('/nav/searchToggle', module._closeLang);
	},

	_initEvents: function () {
		$searchToggle.each(function () {
			$(this).on('click', module._toggleSearch);
		});

		$langToggle.on('click', module._toggleLang);
		$footerSearch.on('click', function (event) {
			event.stopPropagation();
			module._openSearch();
		});

		// Bind escape and enter keys to close search
		$searchInput.on('keydown', function (event) {
			if (event.key === 'Escape' || event.key === 'Enter') {
				module._closeSearch();
			}
		});


		$headerSearchSubmit.on('click', module._closeSearch);

		$body.on('click', function (event) {
			if ($header.length && !$header.is(event.target) && !$header.has(event.target).length) {
				module._closeSearch();
			}
		});
	},


	// publish search toggle event
	// show/hide site search dependant on current state
	// toggle class on search button
	_toggleSearch: function (event) {
		event.preventDefault();

		var state = module._getSearchState();

		publish('/nav/searchToggle');
		if (state === States.OPENED) {
			module._closeSearch();
		} else {
			module._openSearch();
		}
	},

	_getSearchState: function () {
		var expanded = $search.attr('aria-expanded');
		var state;

		if (expanded === 'true') {
			state = States.OPENED;
		} else if (expanded === 'false') {
			state = States.CLOSED;
		} else {
			state = States.INITIAL;
		}


		// Get query string and set it to the search result page header input
		const queryValue = module._getQueryString('ss360Query');
		$searchInput.each(function () {
			$(this).val(queryValue); // Set the value for each input
		});

		return state;
	},

	_openSearch: function () {
		if ($search.length) {
			$search.attr('aria-expanded', true);
			$searchToggle.attr('aria-expanded', true);
			$body.addClass(classes.searchExpanded);
			$searchInput.focus();


			MediaQueries.register([
				{
					// Bind Small Nav
					queries: MediaQueries.queries['megamenu--small'],
					shouldDegrade: false,
					match: function () {
						NavSmall._resetMenu();
					}
				}
			]);
		}
	},

	_closeSearch: function () {
		if ($search.length) {
			$search.attr('aria-expanded', false);
			$searchToggle.attr('aria-expanded', false);
			$body.removeClass(classes.searchExpanded);
		}
	},

	// publish language toggle event
	// show/hide site search dependant on current state
	// toggle class on language button
	_toggleLang: function (event) {
		event.preventDefault();
		publish('/nav/langToggle');
		if ($lang.attr('aria-expanded') === 'true') {
			$lang.attr('aria-expanded', false);
		} else {
			$lang.attr('aria-expanded', true);
		}
		if ($langToggle.attr('aria-expanded') === 'true') {
			$lang.attr('aria-exapnded', false);
		} else {
			$lang.attr('aria-expanded', true);
		}
	},

	// close language picker if open
	_closeLang: function () {
		if ($langToggle.attr('aria-expanded') === 'true') {
			$langToggle.trigger('click');
		}
	},

	_initMediaQueries: function() {

		MediaQueries.register([
			{
				// Bind Small Nav
				queries: MediaQueries.queries['megamenu--small'],
				shouldDegrade: false,
				match: function() {
					NavSmall.init($nav, selectors, classes);
				},
				unmatch: function() {
					NavSmall.unbind($nav, selectors, classes);
				}
			}, {
				// Bind Large Nav
				queries: MediaQueries.queries['megamenu--large'],
				shouldDegrade: true,
				match: function() {
					NavLarge.init($nav, selectors, classes);
				},
				unmatch: function() {
					NavLarge.unbind($nav, selectors, classes);
				}
			}
		]);
	},

	_getQueryString: function (param) {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.get(param);
	}
};

var NavLoad = {
	init: module.init
};

export { NavLoad };
